import { useState } from "react";
import { memo, useEffect } from "react";

function VideoPayer({ item, ...rest }) {
    const [url, setUrl] = useState("");
    useEffect(() => {
        if (typeof item !== "string") {
            setUrl(URL.createObjectURL(item));
        } else {
            setUrl(item);
        }
    }, [item]);
    return <video src={url} {...rest} />;
}
export default memo(VideoPayer, () => false);
